import React from "react";
import { FC } from "react";
import { Theme } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import clsx from "clsx";

interface TextDividerProps {
  text: string;
  className?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  divider: {
    width: "100%",
  },
  rootDivider: {
    marginTop: 8,
    marginBottom: 30,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
  },
  textDivider: {
    fontSize: 12,
    fontWeight: 500,
    background: "#fff",
    padding: "0 13px",
    position: "absolute",
    color: "rgb(187, 187, 187)",
  },
}));

const TextDivider: FC<TextDividerProps> = ({ text, className }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.rootDivider, className)}>
      <Typography component="span" className={classes.textDivider}>
        {text}
      </Typography>
      <Divider className={classes.divider} />
    </div>
  );
};

export default React.memo(TextDivider);
